<template>
  <v-app id="inspire">
    <v-app-bar
        app
        :color="appMainColor"
        :max-width="maxWidth"
    >
      <v-app-bar-nav-icon
          v-if="authenticated && onsite === 'web'"
          @click="drawer = !drawer"
      >
        <v-icon :color="burgerColor">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title :class="mainfontClass" @click="home()">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-navigation-drawer
        v-if="authenticated && onsite === 'web'"
        v-model="drawer"
        app
        disable-resize-watcher
        width="180"
    >
      <v-list
          dense
          class="sidebar"
      >
        <v-list-item
            v-if="authenticated"
        >
          <v-list-item-icon
              class="ml-2 mr-2"
          >
            <v-icon>account_circle</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ user_name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- System User -->
        <!-- Superadmin -->
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Super Admin'"
            @click="superadminPanel">
          <v-list-item-content>
            <v-list-item-title>SuperAdmin Panel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          <v-list-item
              v-if="authenticated && onsite === 'web' && role === 'Super Admin'"
              @click="guide"
              >
              <v-list-item-title>Setup Guide</v-list-item-title>
          </v-list-item>
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Super Admin'"
            @click="create('g')">
          <v-list-item-content>
            <v-list-item-title>Create Group</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Super Admin'"
            @click="create('o')">
          <v-list-item-content>
            <v-list-item-title>Create Outlet</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Super Admin'"
            @click="create('admin')">
          <v-list-item-content>
            <v-list-item-title>Create Admin</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- end Superadmin -->
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Admin'"
            @click="home()"
            link>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Admin -->
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Outlet Admin'"
            @click="outletAdmins()">
          <v-list-item-content>
            <v-list-item-title>Admins</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'Queue Admin'"
            @click="monitorQs()">
          <v-list-item-content>
            <v-list-item-title>All Queues</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!--                <v-list-item-->
        <!--                    v-if="authenticated && onsite === 'web' && role === 'Admin'"-->
        <!--                    @click="adminQueue()"-->
        <!--                    link>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Queues</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!--                <v-list-item-->
        <!--                    v-if="authenticated && onsite === 'web' && role === 'Admin'"-->
        <!--                    @click="adminService()"-->
        <!--                    link>-->
        <!--                    <v-list-item-content>-->
        <!--                        <v-list-item-title>Services</v-list-item-title>-->
        <!--                    </v-list-item-content>-->
        <!--                </v-list-item>-->
        <!-- end Admin -->
        <!-- User -->
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'User'"
            @click="myBooking()"
            link>
          <v-list-item-content>
            <v-list-item-title>Your Booking</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-if="authenticated && onsite === 'web' && role === 'User'"
            @click="pastBooking()"
            link>
          <v-list-item-content>
            <v-list-item-title>Past Booking</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-if="authenticated && onsite === 'web'"
            @click="resetPassword()"
            link>
          <v-list-item-content>
            <v-list-item-title>Reset Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- end User -->
        <v-list-item
            v-if="authenticated && onsite === 'web'"
            @click="logout">
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Guest -->
        <v-list-item
            v-if="!authenticated && onsite === 'web'"
            @click="loginPage"
            link>
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content id="vcontent" class="mt-1">
      <v-container fluid ma-0 pa-0 ma-sm-2 fill-height>
        <slot></slot>
      </v-container>
    </v-content>
    <v-footer
        :color="appMainColor"
        app
        :max-width="maxWidth"
    >
      <span :class="mainfontClass">Aptsys&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import axios from 'axios'


export default {
  data: () => ({
    drawer: false,
  }),
  props: [
    'authenticated', 'title', 'onsite', 'maincolor', 'mainfontcolor', 'role', 'outlet_id', 'user_name', 'user'
  ],
  computed: {
    appMainColor() {
      return this.maincolor !== 'none' ? this.maincolor : 'indigo'
    },
    mainfontClass() {
      let c = this.mainfontcolor !== 'none' ? this.mainfontcolor : 'white';
      return c + '--text'
    },
    burgerColor() {
      return this.mainfontcolor !== 'none' ? this.mainfontcolor : 'white';
    },
    maxWidth() {
      return window.outerWidth
    }
  },
  methods: {
    logout() {
      axios.post('/logout').then(response => {
        window.location.href = '/'
      });
    },
    loginPage() {
      window.location.href = '/login/?oid=' + this.outlet_id;
    },
    registerPage() {
      window.location.href = '/register?oid=' + this.outlet_id;
    },
    superadminPanel() {
      window.location.href = '/superadmin';
    },
    create(param) {
      switch (param) {
        case 'g':
          window.location.href = '/group/create';
          break;
        case 'o':
          window.location.href = '/outlet/create';
          break;
        case 'admin':
          window.location.href = '/admin/create';
      }
    },
    myBooking() {
      window.location.href = '/outlet/' + this.outlet_id + '/my_booking'
    },
    pastBooking() {
      window.location.href = '/outlet/' + this.outlet_id + '/past_booking'
    },
    home() {
      if (this.authenticated) {
        window.location.href = '/'
      } else {
        window.location.href = '/outlet/' + this.outlet_id
      }
    },
    resetPassword() {
      axios.post('/password/email', {
        email: this.user.email
      }).then(response => {
          swal('We have e-mailed your password reset link!')
      }).catch(e => {
          swal({
              title: "Something went wrong",
              text: e,
              icon: 'error'
          })
      })
    },
    outletAdmins() {
      window.location.href = '/outlet/' + this.user.outlet_id + '/admins'
    },
    monitorQs() {
      window.location.href = '/outlet/' + this.user.outlet_id + '/monitor_queues'
    },
    guide() {
        window.open('https://docs.google.com/document/d/1rdbdD9MedSDgCAohEt1Kjx6E7MPQmhDLpDHkl66zmwo/edit?usp=sharing')
    }
    // adminQueue(){
    //     window.location.href = '/'
    // },
    // adminService() {
    //     window.location.href = '/'
    // }
  }
}
</script>

<style scoped>
#vcontent {
  background-color: rgb(247 252 255);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue